<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Expense Approval</h3>
</div>
<div class="modal-body">
    <div *ngIf="multi">
        <p>You are about to <span *ngIf="mode == 'A'">approve</span><span *ngIf="mode == 'R'">reject</span> multiple expense receipts.</p>
        <p *ngIf="pageCount > 0">Selected receipts on this page: {{pageCount}}</p>
        <p>All unapproved receipts: {{allCount}}</p>
    </div>
    <div *ngIf="!multi">
        <p>This action will <span *ngIf="mode == 'A'">approve</span><span *ngIf="mode == 'R'">reject</span> the selected expense receipt(s) .</p>
    </div>
    <div style="margin-top:10px;">
        <label><strong>Notes:</strong></label>
        <input class="form-control" type="text" [(ngModel)]="formData.Notes" [ngClass]="{invalidField: (formData.Notes == null || formData.Notes == '') && mode == 'R'}" />
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="allClicked('A')" *ngIf="mode == 'A' && (single == null && (allCount > pageCount))">Approve All</button>
    <button type="button" class="btn btn-danger" (click)="allClicked('R')" *ngIf="mode == 'R' && (single == null && (allCount > pageCount))" [disabled]="formData.Notes == null || formData.Notes == ''">Reject All</button>
    <button type="button" class="btn btn-success" (click)="pageClicked('A')" *ngIf="mode == 'A' && (pageCount > 0 || single != null)">Approve Selected</button>
    <button type="button" class="btn btn-danger" (click)="pageClicked('R')" *ngIf="mode == 'R' && (pageCount > 0 || single != null)" [disabled]="formData.Notes == null || formData.Notes == ''">Reject Selected</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>